(function (app, ng) {
    app.component("configureReviewWorkflow",
        {
            controller: configureReviewWorkflowController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Review/template.html",
            bindings: {
                transactionGroup: "<",
                onSave: "&"
            }
        });

    configureReviewWorkflowController.$inject = ["_", "figToaster", "figToastContainers", "queueApi", "transactionGroupApi", "permissionService", "$q"];
    function configureReviewWorkflowController(_, figToaster, figToastContainers, queueApi, transactionGroupApi, permissionService, $q) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    selectedQueue: null
                },
                queueWorkflow: null,
                queues: null,
                addReviewQueue: addReviewQueue,
                removeReviewQueue: removeReviewQueue,
                removeEmail: removeEmail,
                addEmail: addEmail,
                addAdditionalEmail: addAdditionalEmail,
                removeAdditionalEmail: removeAdditionalEmail,
                permissionService: permissionService,
                getTransactionGroupQueueWorkflow: getTransactionGroupQueueWorkflow,
                applyReviewerEmails: applyReviewerEmails,
                updateWorkflow: updateWorkflow
            });

        this.$onInit = function () {

            $ctrl.onSave({
                $func: function () {
                    return transactionGroupApi.updateQueueWorkflow($ctrl.queueWorkflow);
                }
            });
            $ctrl.queues = [];
            transactionGroupApi.getQueueWorkflow($ctrl.transactionGroup.QueueWorkflowId).then(function (response) {
                $ctrl.queueWorkflow = response;

                ng.forEach($ctrl.queueWorkflow.Queues, function (queue) {
                    $ctrl.applyReviewerEmails(queue);
                });

                queueApi.getQueues().then(function (queues) {
                    //$ctrl.queues = _.differenceBy(queues, $ctrl.queueWorkflow.Queues, "QueueId");
                    $ctrl.queues = queues;
                });
            });
        };

        function addAdditionalEmail(queue, e) {
            if (e.keyCode === 13) {
                if (!queue.Emails.includes($ctrl.newEmail)) {
                    queue.additionalEmails.push($ctrl.newEmail);
                    addEmail(queue, $ctrl.newEmail);
                    $ctrl.newEmail = "";
                }
            }
        }

        function removeAdditionalEmail(queue, emailToRemove) {
            var index = _.findIndex(queue.additionalEmails,
                function (email) {
                    return email === emailToRemove;
                });
            queue.additionalEmails.splice(index, 1);
            removeEmail(queue, emailToRemove);
        }

        function addEmail(queue, emailToAdd) {
            queue.Emails.push(emailToAdd);
            updateWorkflow(queue);
        }

        function removeEmail(queue, emailToRemove) {
            var index = _.findIndex(queue.Emails,
                function (email) {
                    return email === emailToRemove;
                });
            queue.Emails.splice(index, 1);
            updateWorkflow(queue);
        }

        function updateWorkflow(queue) {
            //queueApi.updateQueueEmails(queue.QueueId, queue.Emails);
            console.log($ctrl.queueWorkflow)
            transactionGroupApi.updateQueueWorkflow($ctrl.queueWorkflow);
        }

        function removeReviewQueue(index) {
            figToaster.showYesNo("Are you sure you would like to remove " +
                $ctrl.queueWorkflow.Queues[index].Name +
                " queue from the workflow?",
                "bottom center",
                figToastContainers.get("remove-queue-workflow"),
                true).then(function (response) {
                    if (!response) return;

                    //$ctrl.queues.push($ctrl.queueWorkflow.Queues[index]);
                    $ctrl.queueWorkflow.Queues.splice(index, 1);
                    transactionGroupApi.updateQueueWorkflow($ctrl.queueWorkflow);
                });
        }

        function addReviewQueue(q) {
            var queue = ng.copy(q);
            $ctrl.applyReviewerEmails(queue).then(function (newQueue) {
                newQueue.Index = $ctrl.queueWorkflow.Queues.length;
                $ctrl.queueWorkflow.Queues.push(newQueue);
                transactionGroupApi.updateQueueWorkflow($ctrl.queueWorkflow);
            });
        }

        function getTransactionGroupQueueWorkflow(queueWorkflowQueues) {
            var promises = []
            ng.forEach(queueWorkflowQueues, function (workflow) {

                promises.push(transactionGroupApi.getTransactionGroupUsers(workflow.TransactionGroupId).then(function (users) {
                    if (workflow.Emails === null)
                        workflow.Emails = [];
                    workflow.additionalEmails = ng.copy(workflow.Emails);
                    workflow.reviewers = [];
                    ng.forEach(users, function (user) {
                        if (user.Roles.includes("Reviewer")) {
                            workflow.reviewers.push(user);
                        }

                        if (workflow.Emails.includes(user.User.Email)) {
                            var index = _.findIndex(workflow.additionalEmails,
                                function (email) {
                                    return email === user.User.Email;
                                });
                            workflow.additionalEmails.splice(index, 1);
                        }
                    });
                }));
            });
        }

        function applyReviewerEmails(queue) {
            return transactionGroupApi.getTransactionGroupUsers(queue.TransactionGroupId).then(function (users) {
                if (queue.Emails === null)
                    queue.Emails = [];
                queue.additionalEmails = ng.copy(queue.Emails);
                queue.reviewers = [];
                ng.forEach(users, function (user) {

                    if (user.User !== null && user.Roles !== null && user.Roles.includes("Reviewer")) {
                        queue.reviewers.push(user);
                    }

                    if (user.User !== null && queue.Emails.includes(user.User.Email)) {
                        var index = _.findIndex(queue.additionalEmails,
                            function (email) {
                                return email === user.User.Email;
                            });
                        queue.additionalEmails.splice(index, 1);
                    }
                });

                return queue;
            });
        }
    };
})(window.app, window.angular); //jshint ignore:line